import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, NEVER, Observable, throwError } from "rxjs";
import { ErrordialogService, IErrorData } from "src/app/cevi-shared/error-dialog/errordialog.service";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private dialogService: ErrordialogService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(err => {

                const isErr = err instanceof HttpErrorResponse;
                
                if (!isErr || err.status===HttpStatusCode.Unauthorized) { return throwError(()=>err);}

                if (err.status === HttpStatusCode.Forbidden) {
                    this.dialogService.setErrorMessage(`Je hebt onvoldoende rechten. ${err.error ? '('+err.error+')': ''}`);
                    return NEVER;
                }

                if (err.headers.get('Redirect')) {
                    window.location.href = err.headers.get('Redirect');
                    return NEVER;
                }

                if (err.status === HttpStatusCode.ServiceUnavailable){
                    this.dialogService.setErrorMessage("Cobra is momenteel niet beschikbaar.");
                    return NEVER;
                }

                if (typeof err.error === 'string' ) { 
                    this.dialogService.setErrorMessage(err.error);
                } else {
                    if (err.error['Type'] != null ) {
                        this.dialogService.setErrorMessage(err.error['Title']);
                        return NEVER;
                    }
                    this.dialogService.setErrorData(<IErrorData>err.error);
                }
                return NEVER;
            })
        );
    }
}